<template>
  <div>
    <h2>
      Invoice {{this.invoiceId}}
      <export-invoice-as-csv :invoice-id="invoiceId"/>
      <export-invoice-as-excel :invoice-id="invoiceId"/>
      <export-invoice-as-excel :invoice-id="invoiceId" :short-version="true"/>
      <v-btn @click="refreshData" icon small>
        <v-icon small>fa-sync</v-icon>
      </v-btn>
      <dev-mode>
        <v-layout>
          <v-flex xs2>
            <re-calculate-invoice-additional-info-form :invoice-id="invoiceId"/>
          </v-flex>
          <v-flex xs2>
            <send-invoice-to-client :invoice-id="invoiceId"/>
          </v-flex>
          <v-flex xs1>
            <modal-json-view :json-data="invoiceInfo" v-if="invoiceInfo"/>
          </v-flex>
        </v-layout>
      </dev-mode>
    </h2>

    <with-invoice :invoice-id="this.invoiceId">
      <template slot="default" slot-scope="{invoice}">

        <send-invoice-to-client :invoice-id="invoiceId" v-if="invoice.status !== 'Draft'"/>

        <client-short-info :client-id="invoice.clientId"/>
        <div>
          {{invoice.from | DateWithMinutes}} - {{invoice.to | DateWithMinutes}}
          <update-invoice-form :current-from="invoice.from"
                               :current-to="invoice.to"
                               :invoice-id="invoice.id"
                               v-if="invoice.status === 'Draft'"/>
        </div>
        <div>
          CasesAdded: {{invoice.additionalInfo.casesAdded}}
        </div>
        <div>
          Sum:
          <b>
            <pretty-amount :amount="invoice.additionalInfo.sumPrice"/>
          </b>
        </div>
      </template>
    </with-invoice>

    <change-invoice-status :invoice-id="invoiceId"/>

    <v-divider/>

    <div>
      <invoice-candidate-logs-filters :invoice-id="invoiceId"/>
      <invoice-candidate-logs :invoice-id="invoiceId"/>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex";
  import {RequestState} from "../../requestState";
  import ModalJsonView from "../../components/Ui/ModalJsonView";
  import InvoiceCandidateLogs from "../../components/analytics/invoices/InvoiceCandidateLogs";
  import ChangeInvoiceStatus from "../../components/analytics/invoices/ChangeInvoiceStatus";
  import InvoiceCandidateLogsFilters from "../../components/analytics/invoices/InvoiceCandidateLogsFilters";
  import ClientShortInfo from "../../components/Ui/mcc/ClientShortInfo";
  import DateWithMinutes from '../../components/Filters/DateWithMinutes'
  import ExportInvoiceAsCsv from "../../components/analytics/invoices/ExportInvoiceAsCsv";
  import ExportInvoiceAsExcel from "../../components/analytics/invoices/ExportInvoiceAsExcel";
  import DevMode from "../../components/Ui/DevMode";
  import AttachCasesWithoutAnomaliesToInvoiceForm
    from "../../components/analytics/invoices/AttachCasesWithoutAnomaliesToInvoiceForm";
  import WithInvoice from "../../components/analytics/invoices/WithInvoice";
  import PrettyAmount from "../../components/Ui/PrettyAmount";
  import ReCalculateInvoiceAdditionalInfoForm
    from "../../components/analytics/invoices/ReCalculateInvoiceAdditionalInfoForm";
  import SendInvoiceToClient from "../../components/analytics/invoices/SendInvoiceToClient";
  import UpdateInvoiceForm from "../../components/analytics/invoices/UpdateInvoiceForm";

  export default {
    name: 'invoice-page',
    components: {
      UpdateInvoiceForm,
      WithInvoice,
      ModalJsonView,
      InvoiceCandidateLogs,
      InvoiceCandidateLogsFilters,
      ClientShortInfo,
      ChangeInvoiceStatus,
      ExportInvoiceAsCsv,
      ExportInvoiceAsExcel,
      DevMode,
      AttachCasesWithoutAnomaliesToInvoiceForm,
      PrettyAmount,
      ReCalculateInvoiceAdditionalInfoForm,
      SendInvoiceToClient
    },
    filters: {
      DateWithMinutes
    },
    data() {
      return {}
    },
    mounted() {
      this.invoicesGetInvoice(this.invoiceId)
    },
    methods: {
      ...mapActions({
        invoicesGetInvoice: 'invoicesGetInvoice',
        invoicesFetchInvoiceLogCandidates: 'invoicesFetchInvoiceLogCandidates',
      }),
      refreshData() {
        this.invoicesGetInvoice(this.invoiceId);
        this.invoicesFetchInvoiceLogCandidates({
          invoiceId: this.invoiceId
        })
      }
    },
    computed: {
      invoiceId() {
        return parseInt(this.$route.params.invoiceId, 10)
      },
      invoiceInfo() {
        return this.$store.getters.getInvoiceInfoById(this.$route.params.invoiceId)
      },
      requestState() {
        if (!this.invoiceInfo) {
          return RequestState.NotPerformed
        }

        return this.invoiceInfo.requestState
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/InvoicePage.vue